import { render, staticRenderFns } from "./editBotPost.vue?vue&type=template&id=1f1426b2&scoped=true&"
import script from "./editBotPost.vue?vue&type=script&lang=js&"
export * from "./editBotPost.vue?vue&type=script&lang=js&"
import style0 from "./editBotPost.vue?vue&type=style&index=0&id=1f1426b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1426b2",
  null
  
)

export default component.exports